import React from 'react'
import { Button, Box } from '@material-ui/core'
import { useHistory } from "react-router-dom";

import Header from './Header';


export default function Dashboard() {
    const history = useHistory()
    const data = [
        {
            id: 1,
            name: 'Pack selection',
            category: 'liquors'
        },
        {
            id: 10,
            name: 'Pack selection (Drinks Delivery)',
            category: 'liquorsDD'
        },
        {
            id: 2,
            name: 'Whiskey 12 Years',
            category: 'Whiskey12'
        },
        {
            id: 11,
            name: 'Whiskey 12 Years (Drinks Delivery)',
            category: 'Whiskey12DD'
        },
        {
            id: 3,
            name: 'Whiskey 15 Years',
            category: 'Whiskey15'
        },
        {
            id: 12,
            name: 'Whiskey 15 Years (Drinks Delivery)',
            category: 'Whiskey15DD'
        },
        {
            id: 4,
            name: 'Whiskey 18 Years',
            category: 'Whiskey18'
        },
        {
            id: 13,
            name: 'Whiskey 18 Years (Drinks Delivery)',
            category: 'Whiskey18DD'
        },
        {
            id: 5,
            name: 'Champagne ',
            category: 'Champagne'
        },
        {
            id: 14,
            name: 'Champagne (Drinks Delivery)',
            category: 'ChampagneDD'
        },
        {
            id: 17,
            name: 'Vodka & liquers',
            category: 'VodkaDD'
        },
        {
            id: 6,
            name: 'Siisha Options',
            category: 'Seesha'
        },
        {
            id: 7,
            name: 'Social Games',
            category: 'Social'
        },
        {
            id: 8,
            name: 'Free of charge',
            category: 'Free'
        },
        {
            id: 15,
            name: 'Other items (Drinks Delivery)',
            category: 'FreeDD'
        },
        {
            id: 9,
            name: 'Discounted',
            category: 'Discounted'
        },
        {
            id: 16,
            name: 'Promo Drinks Delivery',
            category: 'Promo'
        },

    ]
    return (
        <>
            <Header />
            <Box display="flex"
                flexDirection="column"
                justifyContent='center'
                alignItems='center'
                p={1} m={1} bgcolor="background.paper">
                {data.map(item => (
                    <Button key={item.id}
                        onClick={() => history.push('/dashboard/appData', { category: item.category })}
                        style={{ flex: 1, backgroundColor: '#eee', width: '80%', margin: 15, alignSelf: 'center', padding: '1%' }}
                    >
                        {item.name}
                    </Button>
                ))}
            </Box>
        </>
    )
}
